import Vue from 'vue';
import 'element-ui/lib/theme-chalk/index.css';
import { 
    Button,
    Form,
    FormItem,
    Input,
    Container,
    Aside,
    Header,
    Main,
    Menu,
    Submenu,
    MenuItem,
    MenuItemGroup,
    Tabs,
    TabPane,
    Card,
    Table,
    TableColumn,
    Dialog,
    Pagination,
    Row,
    Col,
    Select,
    Option,
    OptionGroup,
    Message,
    MessageBox,
    Drawer,
    Tree,
    Switch,
    Upload,
    Notification,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    CheckboxGroup,
    Checkbox,
    Popover,
    Loading,
    Radio,
    RadioGroup,
    InputNumber,
    Rate,
    DatePicker,
    Empty,
    Alert,
    Tag,
    Tooltip
} from 'element-ui';

Vue.use(Button);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(Container);
Vue.use(Aside);
Vue.use(Header);
Vue.use(Main);
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(MenuItemGroup);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Card);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Dialog);
Vue.use(Pagination);
Vue.use(Row);
Vue.use(Col);
Vue.use(Select);
Vue.use(Option);
Vue.use(OptionGroup);
Vue.use(Drawer);
Vue.use(Tree);
Vue.use(Switch);
Vue.use(Upload);
Vue.use(Dropdown);
Vue.use(DropdownItem);
Vue.use(DropdownMenu);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Popover);
Vue.use(Loading.directive);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(InputNumber);
Vue.use(Rate);
Vue.use(DatePicker);
Vue.use(Empty);
Vue.use(Alert);
Vue.use(Tag);
Vue.use(Tooltip);
Vue.prototype.$loading = Loading.service;
Vue.prototype.$message = Message;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$notify = Notification;
